export default __webpack_public_path__ + "static/media/Intervention.78f2882b.svg";